import { Button, ButtonProps } from "@mui/material";
import { memo } from "react";

interface Props extends ButtonProps {
}

const ButtonApprove = memo(({ ...rest }: Props) => {

  return (
    <Button
      sx={{
        borderRadius: '3px',
        width: '80px',
        height: '28px',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: "unset",
        p: 0
      }}
      variant="contained"
      {...rest}
    />
  )
})

export default ButtonApprove